import { render } from "./dec3Vegas.vue?vue&type=template&id=aa298678"
import script from "./dec3Vegas.vue?vue&type=script&lang=js"
export * from "./dec3Vegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__